import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import Skills from "../assets/header-icons/Vector-3.svg";
import Projects from "../assets/header-icons/Vector.svg";
import Home from "../assets/header-icons/Vector-1.svg";
import Contact from "../assets/header-icons/Vector-4.svg";
import Extras from "../assets/header-icons/Vector-2.svg";
const HeaderC = styled.header`
z-index:11;
  @media (max-width: 450px) {
    width: 100%;
    height: 59px;
    background-color: #3a4449;
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
      justify-content: center;
      align-items: center;
    .navBar {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;

      ol {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        margin: 0;
        list-style: none;

        a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          color: #ffcf49;
          text-decoration: none;
          font-family: "Fira Sans", sans-serif;
          font-weight: 300;
          row-gap: 1em;
          font-size: 9px;
          line-height: 11px;
          img {
            width: 20px;
            min-height: 20px;
          }
        }
      }
    }
  }
  @media (min-width: 450.1px) {
    width: 100px;
    height:100vh;
    background-color: #3a4449;
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
      justify-content: center;
      align-items: center;
    .navBar {
      width:100%;
      height:100vh;
      flex-direction: column;
      height: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      ol {
        width:100%;
      height:90vh;
        display: flex; 
        justify-content: space-between;
        align-items: space-between;
        padding: 0 10px;
        margin: 0;
        flex-direction: column;
        list-style: none;

        a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          color: #ffcf49;
          text-decoration: none;
          font-family: "Fira Sans", sans-serif;
          font-weight: 300;
          row-gap: 1em;
          font-size:20px;
          line-height: 11px;
          img {
            width: 36px;
            min-height: 20px;
          }
        }
      }
    }
  }
`;
function Header() {
  return (
    <>
      <HeaderC>
        <nav className="navBar">
          <ol>
            <li>
              <Link to="/skills">
                <img src={Skills} />
                Skills
              </Link>
            </li>
            <li>
              <Link to="/projects">
                <img src={Projects} />
                Projects
              </Link>
            </li>
            <li>
              <Link to="/">
                <img src={Home} />
                Home
              </Link>
            </li>
            <li>
              <Link to="/contact">
                <img src={Contact} />
                Contact
              </Link>
            </li>

            <li>
              <Link to="/extra">
                <img src={Extras} />
                Extras
              </Link>
            </li>
          </ol>
        </nav>
      </HeaderC>
    </>
  );
}

export default Header;
